import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./components/pages/home";
import Users from "./components/pages/users";
import Notices from "./components/pages/notices";
import Academy from "./components/pages/academy";
import Costing from "./components/pages/costing";
import Monthly from "./components/pages/monthly";
import Coverage from "./components/pages/coverage";
import Reachback from "./components/pages/reachback";
import Shopify from "./components/pages/shopify";
import Metrics from "./components/pages/metrics";

import SuperTokens, {
  getSuperTokensRoutesForReactRouterDom,
} from "supertokens-auth-react";
import ThirdParty from "supertokens-auth-react/recipe/thirdparty";
import Session, {
  useSessionContext,
} from "supertokens-auth-react/recipe/session";

import { platformUploadJWT } from "./components/helpers/localStorageHelper";
import PlatformAuth from "./components/helpers/platformAuth";

// Enables DevExtremes dark UI mode
import "devextreme/dist/css/dx.dark.css";
import "react-toastify/dist/ReactToastify.css";

// Enables the global config
import "./config";
import { ToastContainer } from "react-toastify";

SuperTokens.init({
  languageTranslations: {
    translations: {
      en: {
        BRANDING_POWERED_BY_START: "Power by Built Intelligence and ",
        THIRD_PARTY_SIGN_IN_AND_UP_HEADER_TITLE: "Azure AD Login",
      },
    },
    defaultLanguage: "en",
  },
  appInfo: {
    appName: "Platform Analytics",
    apiDomain: global.config.backend.superTokensMiddleWare,
    websiteDomain: window.location.origin,
  },
  recipeList: [
    ThirdParty.init({
      override: {
        components: {
          ThirdPartySignInAndUpHeader_Override: ({
            DefaultComponent,
            ...props
          }) => {
            return (
              <div>
                <img
                  style={{ maxWidth: "100%" }}
                  src="https://cdn.shopify.com/s/files/1/0248/4926/files/BI_logo_300x90_300x90.png?v=1613712008"
                  alt="Built Intelligence"
                />
                <DefaultComponent {...props} />
              </div>
            );
          },
        },
      },
      signInAndUpFeature: {
        style: {
          providerButton: {
            backgroundColor: "#3f96c4 !important",
            color: "#fff !important",
            borderColor: "#3f96c4 !important",
          },
          container: {
            backgroundColor: "#303030 !important",
            borderRadius: "25px",
          },
          headerTitle: {
            color: "#fff",
          },
          superTokensBranding: {
            backgroundColor: "#2a2a2a !important",
            paddingBottom: "5px !important",
            color: "#999999 !important",
            marginTop: "20px !important",
          },
          row: {
            padding: "10px !important",
          },
        },
        providers: [
          {
            id: "fastdraftssoazuread",
            name: "Built Intelligence SSO",
          },
        ],
      },
    }),
    Session.init(),
  ],
});

function App() {
  let sessionContext = useSessionContext();

  useEffect(() => {
    if (
      sessionContext &&
      !sessionContext.loading &&
      sessionContext.doesSessionExist &&
      sessionContext.accessTokenPayload &&
      sessionContext.accessTokenPayload.access_token
    ) {
      platformUploadJWT(sessionContext.accessTokenPayload.access_token);
    }
  }, [sessionContext]);

  return (
    <BrowserRouter>
      <ToastContainer
        containerId={"Axios"}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        rtl={false}
        pauseOnHover
        theme="light"
      />
      <div className="fullscreen-tooltip d-none">Click to Exit</div>
      <div>
        <main>
          <Routes>
            {/* This shows the login UI on "/auth" route */}
            {getSuperTokensRoutesForReactRouterDom(require("react-router-dom"))}

            <Route
              path="*"
              element={
                <PlatformAuth>
                  <Home />
                </PlatformAuth>
              }
            />
            <Route
              path="/home"
              element={
                <PlatformAuth>
                  <Home />
                </PlatformAuth>
              }
            />
            <Route
              path="/users"
              element={
                <PlatformAuth>
                  <Users />
                </PlatformAuth>
              }
            />
            <Route
              path="/notices"
              element={
                <PlatformAuth>
                  <Notices />
                </PlatformAuth>
              }
            />
            <Route
              path="/monthly"
              element={
                <PlatformAuth>
                  <Monthly />
                </PlatformAuth>
              }
            />
            <Route
              path="/academy"
              element={
                <PlatformAuth>
                  <Academy />
                </PlatformAuth>
              }
            />
            <Route
              path="/costing"
              element={
                <PlatformAuth>
                  <Costing />
                </PlatformAuth>
              }
            />
            <Route
              path="/coverage"
              element={
                <PlatformAuth>
                  <Coverage />
                </PlatformAuth>
              }
            />
            <Route
              path="/reachback"
              element={
                <PlatformAuth>
                  <Reachback />
                </PlatformAuth>
              }
            />
            <Route
              path="/shopify"
              element={
                <PlatformAuth>
                  <Shopify />
                </PlatformAuth>
              }
            />
            <Route
              path="/metrics"
              element={
                <PlatformAuth>
                  <Metrics />
                </PlatformAuth>
              }
            />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
